import { render } from "./Pulse.vue?vue&type=template&id=788b0762&ts=true"
import script from "./Pulse.vue?vue&type=script&lang=ts"
export * from "./Pulse.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__